"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeakSet = void 0;
exports.isWeakSet = (value) => value instanceof WeakSet;
//# sourceMappingURL=is-weak-set.js.map